export default __webpack_public_path__ + "static/media/svgback.3f3cb9a5.svg";